export const isFromZaraRedirect = (): boolean => {
  const currentUrl = window.location.href;
  const referrerUrl = document.referrer;
  const storedRedirectState = sessionStorage.getItem('zaraRedirect');
  
  const redirectPatterns = [
    '/redirect/product-detail/',
    '/redirect/products/detail/',
    '/redirect/communication/',
    '/redirect/products/ask-details/',
    '/redirect/communication/ask-details/',
    '/redirect/account/orders',
    '/redirect/account/my-sells',
    '/redirect/my-purchases',
    '/redirect/my-sales',
    '/redirect/user/cart',
    '/redirect/user/profile'
  ];
  
  const isRedirectUrl = redirectPatterns.some(pattern => 
    currentUrl.includes(pattern) || referrerUrl.includes(pattern)
  );
  
  return isRedirectUrl || !!storedRedirectState;
};

export const setZaraRedirectState = (): void => {
  sessionStorage.setItem('zaraRedirect', 'true');
};

export const clearZaraRedirectState = (): void => {
  sessionStorage.removeItem('zaraRedirect');
};